// const { children } = require("@splidejs/splide/src/js/utils");

let currentPage = 1;
const itemsPerPage = 8;
const gridContainer = document.querySelector(".event-grid");
const items = Array.from(document.querySelectorAll(".event-grid .grid__item"));
const totalPages = Math.ceil(items.length / itemsPerPage);

const prevBtn = document.querySelector(".pagination .prev");
const nextBtn = document.querySelector(".pagination .next");
const bulletsContainer = document.querySelector(".pagination .bullets");

function showPage(page, direction = "right") {

  // Add animation class (slide out)
  if(totalPages == 1){
   
     document.querySelector(".pagination").classList.add("no-show");
  }
  // else{
    if(document.querySelector(".event-grid")){
        gridContainer.classList.remove("show");
        gridContainer.classList.add(`slide-${direction}`);
    
        setTimeout(() => {
        // Hide all items
        items.forEach((item) => (item.style.display = "none"));
    
        // Show only the current page items
        const start = (page - 1) * itemsPerPage;
        const end = page * itemsPerPage;
        const pageItems = items.slice(start, end);
        pageItems.forEach((item) => (item.style.display = ""));
    
        // Animate in
        gridContainer.classList.remove("slide-left", "slide-right");
        gridContainer.classList.add("show");
    
        updateDots(page);
        updateNavButtons();
        }, 400); // match with CSS transition
  }
  // }
  
 
}

function updateDots(page) {
  bulletsContainer.innerHTML = "";

  for (let i = 1; i <= totalPages; i++) {
    const dot = document.createElement("span");
    dot.classList.add("dot");
    if (i === page) dot.classList.add("active");

    dot.addEventListener("click", () => {
      const direction = i > currentPage ? "right" : "left";
      currentPage = i;
      showPage(currentPage, direction);
    });

    bulletsContainer.appendChild(dot);
  }
}

function updateNavButtons() {
  prevBtn.disabled = currentPage === 1;
  nextBtn.disabled = currentPage === totalPages;
}
if(document.querySelector(".pagination .next")){
    nextBtn.addEventListener("click", () => {
        if (currentPage < totalPages) {
          currentPage++;
          showPage(currentPage, "right");
        }
      });
}
if(document.querySelector(".pagination .prev")){
    prevBtn.addEventListener("click", () => {
        if (currentPage > 1) {
          currentPage--;
          showPage(currentPage, "left");
        }
      });
}

// Init
showPage(currentPage);



document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelectorAll(".tooltip-content")){
    const svgSpots = document.querySelectorAll('[data-spot-index]');
    const tooltips = document.querySelectorAll(".tooltip-content");
  
    svgSpots.forEach(spot => {
      const index = spot.getAttribute('data-spot-index');
      const tooltip = document.querySelector(`.tooltip-content[data-spot-index="${index}"]`);
      
      
      if (tooltip) {
        spot.addEventListener("mouseenter", () => {
          showTooltip(spot, tooltip.innerHTML);
        });
  
        spot.addEventListener("mouseleave", () => {
          hideTooltip();
        });
      }
    });
  }
  

 

  function showTooltip(target, content) {
    
    
    let tooltipDiv = document.createElement("div");
    tooltipDiv.className = "custom-tooltip";
    tooltipDiv.innerHTML = content;
    document.body.appendChild(tooltipDiv);
    // console.log(tooltipDiv);
    const rect = target.getBoundingClientRect();
    tooltipDiv.style.top = rect.top + window.scrollY - 40 + "px";
    tooltipDiv.style.left = rect.left + window.scrollX + "px";
  }

  function hideTooltip() {
    const existing = document.querySelector(".custom-tooltip");
    if (existing) existing.remove();
  }

});

let searchInput = document.querySelector("#grid-search-input");
if (searchInput) {

	searchInput.addEventListener("keyup", function (e) {
		
    e.preventDefault();
   
		if (e.keyCode === 13) {
			filterSearch(document.getElementById("grid-search-input").value);
		}
		
	});
}
  
const filterSearch =  function(criteria){
    let gridItems = document.querySelectorAll(".grid__item");
   
    if (criteria.trim() === "") {
      gridItems.forEach(item => item.style.display = "block");
      return;
    }
    const lowerCriteria = criteria.toLowerCase();
   
    for (const item of gridItems) {
      item.style.display = "none"; //
      if (item.textContent.toLowerCase().indexOf(lowerCriteria) !== -1) {
        item.style.display = "block"; 
      }
    }
}

jQuery( function($) {

  let selectedCategories = [];
  let selectedStartDate = null;
  let selectedEndDate = null;

  const $selectedItems = $('#filter-category');
  const $dropdown = $('#customDropdown');

  window.toggleDropdown = function () {
    $dropdown.toggleClass('active');
  };
  // Update selected items
  function updateSelectedItems() {
    const $checkboxes = $dropdown.find('input[type="checkbox"]');
   
    $selectedItems.empty();
    let hasSelected = false;
    selectedCategories = []; 
    $checkboxes.each(function () {
      if ($(this).is(':checked')) {
        hasSelected = true;
        const value = $(this).val();
        const $tag = $('<div class="tag"></div>').text(value);
        const $remove = $('<span>&times;</span>');

        selectedCategories.push(value);

        $remove.on('click', () => {
          $(this).prop('checked', false);
          
          selectedCategories.pop($(this).val());
          updateSelectedItems();
          filterCards();

        });

        $tag.append($remove);
        $selectedItems.append($tag);
      }
    });

    if (!hasSelected) {
      $selectedItems.html('<span style="color: #888;">Choose categories...</span>');
    }

    // Auto-close dropdown
    $dropdown.removeClass('active');
  }
  if ($dropdown.length) {
    $dropdown.find('input[type="checkbox"]').on('change', updateSelectedItems);
    $dropdown.find('input[type="checkbox"]').on('change', filterCards);

    $(document).on('click', function (e) {
      if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
        $dropdown.removeClass('active');
      }
    });
  }

  $("#filter-date").daterangepicker({
      presetRanges: [],
      cancelButtonText: "",
      altFormat: "dd-mm-yy",
      datepickerOptions : {
          numberOfMonths : 2,
          minDate: null,  // allows past dates
          maxDate: null,   // allows future dates
      },
  });
  $("#filter-date").on('change', function(event) {
    let selectedDate = $('#filter-date').val();
    if(selectedDate){
      selectedDate = JSON.parse(selectedDate);
      selectedStartDate = moment(selectedDate['start'], 'DD/MM/YYYY');
      selectedEndDate = moment(selectedDate['end'], 'DD/MM/YYYY');
     
      filterCards();
    }
    else{
      resetFilters();
      // $('.grid__item.card').each(function (){
      //   const card = $(this);
      //   $('#no-results').hide();
      //   card.show();
      // });
    }
  });

  // Reset the event filters
  $('#reset-filters button').on('click', function () {
      resetFilters();
  });
  function resetFilters(){
    $('.comiseo-daterangepicker-triggerbutton').text("select Date Range...");
    
      $('#customDropdown').find('input[type="checkbox"]').each(function () {
        $(this).prop('checked', false);
        updateSelectedItems();
      })
      $('.grid__item.card').each(function (){
        const card = $(this);
        $('#no-results').hide();
        $('#reset-filters').hide();
        card.show();
      });
  }
   // Filtering logic
   function filterCards() {
    // const searchTerm = $searchInput.val().toLowerCase().trim();
    let matchFound = false;
    
      $('.grid__item.card').each(function () {
          const card = $(this);
          const cardCategory = card.data('category');
          const formattedDate = card.data('date').replaceAll('/', '-');
          // const cardDate = moment(formattedDate, 'YYYY-MM-DD');
          const rawDate = card.attr('data-date'); 
          const cardDate = moment(rawDate, 'DD/MM/YYYY');

          const categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(cardCategory);
          const dateMatch = (!selectedStartDate || !selectedEndDate) || 
              (cardDate.isSameOrAfter(selectedStartDate, 'day') && cardDate.isSameOrBefore(selectedEndDate, 'day'));
              
          if (categoryMatch && dateMatch) {
              card.show();
              matchFound = true;
              $('#reset-filters').show();
          } else {
             
              card.hide();
          }
          if (matchFound) {
            $('#no-results').hide();
            // $('#reset-filters').hide();
          } else {
            $('#no-results').show();
            $('#reset-filters').show();
          }
          // const $tag = $('<div class="tag"></div>').text(value);
      });
  }
    // $("ul.subTab li").click(function() {

    //   $("ul.subTab li").removeClass('active');
    //   $(".subTab-content").removeClass('active')
    //   $(".tag").removeClass('active');
      
    //   let tabID = $(this).data('id');

    //   $(this).addClass('active');
    //   $(".tag[data-id='" + tabID + "']" ).addClass('active');
    //   $(".subTab-content[data-id='tab" + tabID + "']" ).addClass('active');
    // });

    $(".tabs__label").click(function() {
    
      $("ul.subTab li").removeClass('active');
      $(".subTab-content").removeClass('active');
      $(".tag[data-id='0']").addClass('active');
      $(".subTab-content[data-id='tab0']").addClass('active');
      $("ul.subTab li[data-id='0']").addClass('active');
      $(".mobile-select span").text("");
      // changeMobileTab( $("ul.subTab li[data-id='0']").html());
    });
    

    $(document).ready(function () {
    
      // Click on tab (desktop)
      $("ul.subTab li").click(function () {
          $("ul.subTab li").removeClass('active');
          $(this).addClass('active');

          $(".subTab-content").removeClass('active')
          $(".tag").removeClass('active');
      
          let tabID = $(this).data("id");
          $(".tag[data-id='" + tabID + "']" ).addClass('active');
          $(".subTab-content[data-id='tab" + tabID + "']" ).addClass('active');
          // showTab(tabID);
      });
  
  });


  $(".select").click(function() {
      
     changeMobileTab( $("ul.subTab li[data-id='0']").html());
    // if($(".select").hasClass('mobile')){
      var is_open = $(this).hasClass("open");
      if (is_open) {
        $(this).removeClass("open");
      } else {
        $(this).addClass("open");
      }
    // }
    
  });

  $(".select li").click(function() {

    var selected_value = $(this).html();
    $(".select span").html(selected_value);
    // Hide all by default
    // const $map = $(".LOCATION-MAP");
    // $map.find('.RIDESHARE, .METRO, .PARKING').hide();

    // // Determine what to show based on class
    // if ($(this).hasClass('location')) {
    //   $map.find('.RIDESHARE, .METRO, .PARKING').show();
    // }
    // if ($(this).hasClass('driving_directions')) {
    //   // Already hidden by default
    // }
    // if ($(this).hasClass('general_parking')) {
    //   $map.find('.PARKING').show();
    // }
    // if ($(this).hasClass('public_transportation')) {
    //   $map.find('.METRO').show();
    // }
    // if ($(this).hasClass('rideshare')) {
    //   $map.find('.RIDESHARE').show();
    // }

  });
 
  $('.mobile-select').click(function() {
    
      var is_open = $(this).hasClass("open");
      if (is_open) {
        $(this).removeClass("open");
      } else {
        $(this).addClass("open");
      }
    
  });
  $(".mobile-select li").click(function() {

    var selected_value = $(this).html();
    changeMobileTab(selected_value);
  
  });
  function changeMobileTab(tabHtml){
    $(".mobile-select span").html(tabHtml);
  }
  if (window.location.pathname === '/getting-here/') {
    $(".select span").html($(".tabs__label[data-id='0']").html());
  }
 
});


// document.addEventListener("DOMContentLoaded", function () {
 
//   if (window.location.pathname === '/getting-here/') {
    
//       const firstTab = document.querySelector(".location");
//       if (firstTab) {
//         console.log('====================================');
//         console.log(firstTab);
//         console.log('====================================');
//           firstTab.addEventListener("click");
//       }
//   }
// });
